<template>
  <aside id="cookie_modal" class="mx-3 p-3 p-xl-4" :class="{'d-none': !showCookiesModal}">
    <form method="POST" id="cookie-consent" v-if="showCookiesModal">
      <input type="hidden" name="action" value="eshopAction">
      <input type="hidden" name="subAction" value="cookieConsent">
      <input type="hidden">
      <div class="row">
        <div class="col-12">
          <p class="title h3 text-second fw-normal py-3">
            {{ $t('cookies-header') }}
          </p>
          <p class="subtitle text-muted">
            {{ $t('cookies-lista') }}
          </p>
        </div>
        <div class="col-12">
          <div class="cookie-consent-body">
            <div id="cookie-additional-settings" class="additional-settings" v-if="collapseOpen">
              <div class="row">
                <div class="col-12">
                  <label class="container">{{ $t('needed') }}
                    <input type="checkbox" name="necessary" value="1" checked="checked" disabled>
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div class="col-12">
                  <label class="container" for="c_panel_marketing">{{ $t('marketing') }}
                    <input type="checkbox" name="c_panel_marketing" id="c_panel_marketing" value="1"
                           v-model="cookiesPolicy.marketing">
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div class="col-12">
                  <label class="container" for="c_panel_analytics">{{ $t('analysis') }}
                    <input type="checkbox" name="c_panel_analytics" id="c_panel_analytics" value="1"
                           v-model="cookiesPolicy.analytics">
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
            <a class="cookie btn" href="#" @click="collapseOpen = !collapseOpen"> {{
                $t('cookies-option')
              }}</a>
            <div class="row cc-btns mt-4 mb-3">
              <div class="col-12 mb-2">
                <button aria-label="accept cookie message" id="consentButtonAgree" role="button"
                        type="button"
                        class="btn btn-block w-100 btn-first btn-rounded text-white"
                        @click="submitCookies">
                  <span v-if="acceptAll">{{ $t('accept-all') }}</span>
                  <span v-else>{{ $t('agree-with-selected') }}</span>
                </button>
              </div>
              <div class="col-12">
                <button aria-label="dismiss cookie message" role="button"
                        class="btn btn-block btn-rounded w-100 btn-light" type="button"
                        @click="rejectCookies">
                  {{ $t('rejected') }}
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-12 cookie-consent-margin">
                <NuxtLink class="more text-under"
                          :to="`/${activeLocale.code}-${activeCountry.code}/cookies-policy`"
                          target="_blank">
                  {{ $t('more-info') }}
                </NuxtLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      <PartsTempPreloader v-if="loading"/>
    </form>
  </aside>
</template>

<script setup lang="ts">
import {computed, onMounted, ref} from "vue";
import {obtainActiveLocale, obtainActiveWebCountry} from "../../../composables/master_page";
import {useRuntimeConfig} from "#app";

const collapseOpen = ref(false);
const loading = ref(false);
const hidden = ref(false);
const cookiesPolicy = ref({analytics: false, marketing: false});
const activeLocale = obtainActiveLocale();
const activeCountry = obtainActiveWebCountry();
import {GATracker} from "../../../composables/ga_tracker";

const {initGTM, GATrackEvent} = GATracker();

const acceptAll = computed(() => {
  return collapseOpen.value === false || (cookiesPolicy.value.analytics === true && cookiesPolicy.value.marketing === true)
})

const cookiePolicy = computed(() => {
  return localStorage && typeof localStorage.getItem('cookies_policy') === 'string' ? JSON.parse(localStorage.getItem('cookies_policy')) : {
    analytics: false,
    marketing: false,
    checked: false
  };
})

const showCookiesModal = computed(() => {
  return hidden.value === false && cookiePolicy.value.checked !== true;
})

onMounted(() => {
  initGTM();
})


const rejectCookies = () => {
  localStorage.setItem('cookies_policy', JSON.stringify({analytics: false, marketing: false, checked: true}));
  hidden.value = true;
}

const submitCookies = () => {
  localStorage.setItem('cookies_policy', JSON.stringify(acceptAll.value ? {
    analytics: true,
    marketing: true,
    checked: true
  } : {
    analytics: cookiesPolicy.value.analytics,
    marketing: cookiesPolicy.value.marketing,
    checked: true
  }));
  hidden.value = true;
  initGTM();
}

</script>
